/* Audit Assistant — typing indicator (● ● ● animated dots). */
import type { JSX } from 'react';

export function TypingIndicator(): JSX.Element {
  return (
    <div className="aa-msg aa-msg-assistant" aria-live="polite" aria-label="Audit Assistant is typing">
      <div className="aa-avatar" aria-hidden="true">AI</div>
      <div className="aa-bubble aa-bubble-assistant aa-typing">
        <span className="aa-dot" />
        <span className="aa-dot" />
        <span className="aa-dot" />
      </div>
    </div>
  );
}
